import { doAction } from '@situation/setdesign.util';

const calendarSettings = {
    defaultView: 'month',
    timeFormat: 'h:mmA',
    aspectRatio: 1.1,
    weekMode: 'variable',
    fixedWeekCount: false,
    height: 'auto',
    theme: false,
    customButtons: {},
    header: { left: '', center: 'prev,title,next', right: '' },
    viewRender(view, element) {
        doAction('calendar/viewRender', view, element);
    },
    eventRender(event, element, view) {
        doAction('calendar/eventRender', event, element, view);
    },
    eventClick(event, jsEvent, view) {
        doAction('calendar/eventClick', event, jsEvent, view);
    },
};

export default calendarSettings;
